import { Submenu } from "./Submenu";
import { MobileMenu } from "./MobileMenu";

const MENU_SELECTOR = ".menu--main";
const HAS_SUBMENU_SELECTOR = ".has-submenu";

/**
 * Menu
 */
(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.nsrc_menu = {
    attach: function (context, settings) {
      let submenus = [];

      //   handler to pass to each submenu
      // const closeAll = () => {
      // submenus.forEach(function (submenu) {
      //   submenu.closeInstant();
      // });
      // };

      //   init menu, should only be 1
      context.querySelectorAll(MENU_SELECTOR).forEach((menu) => {
        // init mobile menu toggle
        new MobileMenu(menu);
        // init submenus in menu
        menu.querySelectorAll(HAS_SUBMENU_SELECTOR).forEach((element) => {
          submenus.push(new Submenu(element));
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
